import { createSlice } from '@reduxjs/toolkit';

import type { DefaultSNSValues } from '../apiTypes';
import { fetchDefaultSNSList } from './actions';
import type { DefaultSNSValuesState } from './types';

const initialState: DefaultSNSValuesState = {
  data: [],
  loading: false,
  error: null,
  isSnsDataUpdating: false,
} as {
  data: DefaultSNSValues[];
  loading: boolean;
  error: string | null;
};

export const snsDefaultValueSlice = createSlice({
  name: 'snsDefaultValue',
  initialState: initialState,
  reducers: {
    setDefaultSNSValue(state, action) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDefaultSNSList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDefaultSNSList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDefaultSNSList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to Fetch';
      });
  },
});

export const { setDefaultSNSValue } = snsDefaultValueSlice.actions;
export const snsDefaultValueReducer = snsDefaultValueSlice.reducer;
